<div class="main">
    <div class="icon-text">
        <div class="icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#000D4D" stroke-opacity="0.45" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
        <div class="text-container">
            <div class="subtitle">Instructions</div>
            <div class="title">
                @switch(data.for) {
                    @case ('basicIdea') {
                        The Basic Idea
                    }
                    @case ('userTinder') {
                        User Tinder
                    }
                    @case ('problemShadowing') {
                        Problem Shadowing
                    }
                }
            </div>
        </div>
    </div>
    <div class="content">
        <div class="image"></div>
        @switch(data.for) {
            @case ('basicIdea') {
                <div>We'll guide you in three simple steps:</div>
                <div class="bullet-container">
                    <div class="bullet">
                        <div class="icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="#000D4D" stroke-opacity="0.45" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div class="bullet-text">
                            <div class="bullet-header">The Problem</div>
                            <div>What challenge are you solving</div>
                        </div>
                    </div>
                    <div class="bullet">
                        <div class="icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="#000D4D" stroke-opacity="0.45" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div class="bullet-text">
                            <div class="bullet-header">The People</div>
                            <div>Who are your users? What do they need?</div>
                        </div>
                    </div>
                    <div class="bullet">
                        <div class="icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="#000D4D" stroke-opacity="0.45" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div class="bullet-text">
                            <div class="bullet-header">The Solution</div>
                            <div>How does your idea create value?</div>
                        </div>
                    </div>
                </div>
            }
            @case ('userTinder') {
                <div>Next step is crucial because understanding your users guides better decisions. Please keep in mind:</div>
                <div class="bullet-container">
                    <div class="bullet">
                        <div class="icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="#000D4D" stroke-opacity="0.45" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div class="bullet-text">
                            <div class="bullet-header">Focus on your first users</div>
                            <div>Your AI Coach suggests potential users. Pick the ones you want as early adopters for your product.</div>
                        </div>
                    </div>
                    <div class="bullet">
                        <div class="icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="#000D4D" stroke-opacity="0.45" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div class="bullet-text">
                            <div class="bullet-header">Users & Anti-Users</div>
                            <div>Who loves it? Who doesn’t? Understanding both helps refine your concept.</div>
                        </div>
                    </div>
                </div>
            }
            @case ('problemShadowing') {
                <div class="content-header">How it works</div>
                <div class="bullet-container">
                    <div class="bullet">
                        <div class="icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="#000D4D" stroke-opacity="0.45" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div class="bullet-text">
                            <div class="bullet-header">Uncover Hidden Pain Points</div>
                            <div>Users often struggle in ways they don’t articulate. Shadowing them helps reveal friction and unmet needs.</div>
                        </div>
                    </div>
                    <div class="bullet">
                        <div class="icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="#000D4D" stroke-opacity="0.45" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div class="bullet-text">
                            <div class="bullet-header">Validate Before You Build</div>
                            <div>By understanding problems first, you avoid investing in the wrong solutions. Insight-driven ideas are far more likely to succeed.</div>
                        </div>
                    </div>
                </div>
            }
        }
    </div>
    <div class="button-group">
        <div class="checkbox">
            <rr-checkbox size="small" (checkedChanged)="skipNextTime($event)"></rr-checkbox>
            <div class="checkbox-text">Skip next time</div>
        </div>
        <rr-btn type="Primary" tone="brand" iconEnd="arrow-right" (btnclick)="goAhead()">Go ahead</rr-btn>
    </div>
</div>